import {
  SET_ACTIVE_PROFILE,
  UPDATE_ACTIVE_PROFILE
} from './types'

// API
import * as API  from '../utils/api';

export const setActiveProfile = (username) => dispatch => {
  return new Promise((resolve, reject) => {
    API.getProfile(username)
    .then(response => {
      if (response.errors) {
        reject('Error')
      } else {
        let responseObject = {
          success: true
        }

        dispatch(receiveProfile(response))
        resolve(responseObject)
      }
    }).catch(error => {
      console.log('there was an error: ', error);
    });
  })
}

export const updateActiveProfile = (user, username, profile) => dispatch => {
  return new Promise((resolve, reject) => {
    API.updateProfile(user, username, profile)
    .then(response => {
      if (response.error) {
        reject('Error')
      } else {
        const combinedProfile = Object.assign(profile, response);

        let responseObject = {
          success: true
        }

        dispatch(updateProfile(combinedProfile))
        resolve(responseObject)
      }
    }).catch(error => {
      console.log('there was an error: ', error);
    });
  })
}


const receiveProfile = (profile) => ({
  type: SET_ACTIVE_PROFILE,
  profile
});

const updateProfile = (profile) => ({
  type: UPDATE_ACTIVE_PROFILE,
  profile
});


// WEBPACK FOOTER //
// ./src/actions/activeProfile.js